import { Field, useFormikContext } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import Label from '../label/label';
import { CanGoNext } from "../../models/CanGoNext";
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { SelectListField } from '../enrolmentCategoryWizard/SelectListField';
import { SettingTextField } from '../settingFields/SettingTextField';
import SettingSelectField from '../settingFields/SettingSelectField';

export interface DetailFields {
    displayName: string;
    description: string;
    copyOf: string;
    singleOwner: boolean;
    autoIdNumber: boolean;
}

interface MasterDetailGroupTypeProps extends CanGoNext {
    options?: any;
    setSideBarStepDescription?: (newDescription) => void;
    masterGroupTypeOptions?: any
    onBack?: any
}

const MasterDetailGroupType: FC<MasterDetailGroupTypeProps> = ({ onBack, masterGroupTypeOptions, onNext, options = [], setSideBarStepDescription = () => { } }) => {
    const { translate } = useLocale();
    const [uiTypeSelected, setUiTypeSelected] = useState(false);
    const { errors, values, setFieldValue } = useFormikContext() as any;
    const [hasError, setHasError] = useState(false);
    const [selectedOption, setSelectedOption] = useState(1) as any;

    useEffect(() => {
        if (Object.keys(errors as any).length > 0) {
            setHasError(true)
        }
        else {
            setHasError(false)
        }
    }, [errors])

    const handleSelection = item => {
        setUiTypeSelected(true);
    }

    const handleRadioSelection = (type) => {
        if (type === 1 || type === null) {
            setSelectedOption(type)
            setFieldValue('newGroupName', '')
        } else {
            setSelectedOption(type)
            setFieldValue('masterDetailGroupType', null)
        }
    }

    return <div className="pt-3 pr-3 h-full relative">
        <div className="mt-2">
            <div className="radio">
                <input
                    type="radio"
                    value={1}
                    checked={selectedOption === 1}
                    onChange={() => handleRadioSelection(1)}
                />
                <Label htmlFor="masterDetailGroupType"
                    className="text-xs text-gray-600 ml-2"
                >{translate.byKey(TranslationKeys.selectGroup)}</Label>
            </div>
            <div className="radio">

                <input
                    type="radio"
                    value={2}
                    checked={selectedOption === 2}
                    onChange={() => handleRadioSelection(2)}
                />
                <Label htmlFor="masterDetailGroupType"
                    className="text-xs text-gray-600 ml-2"
                >{translate.byKey(TranslationKeys.createGroup)}</Label>

            </div>
        </div>
        {selectedOption === 1 || selectedOption === null ? <div className="flex flex-col ">
            <Label htmlFor="masterDetailGroupType"
                className="text-xs text-gray-600 mt-3"
                required>{translate.byKey(TranslationKeys.group)}:</Label>
            <SettingSelectField
                key={"masterDetailGroupType"}
                accessor={"masterDetailGroupType"}
                options={masterGroupTypeOptions}
                onSelect={handleSelection}
                className="">
            </SettingSelectField>
        </div> :
            <div className="flex flex-col mt-3">

                <SettingTextField
                    required
                    accessor={'newGroupName'}
                    isCard
                    displayName={translate.byKey(TranslationKeys.newGroupName)}></SettingTextField>
            </div>}
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 w-full">
            <button
                className="secondary secondary-inverse mr-3 py-1 px-5"
                type="button" onClick={onBack}>
                {translate.byKey(TranslationKeys.back)}
            </button>
            <button
                className={`secondary py-1 px-5 ${(values.masterDetailGroupType || values.newGroupName) && !hasError ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                type="button"
                onClick={(values.masterDetailGroupType || values.newGroupName) && onNext ? (e) => {
                    if (!hasError) {
                        onNext(e);
                        setSideBarStepDescription(values.newGroupName ? values.newGroupName : masterGroupTypeOptions.find((item) => item.value === values.masterDetailGroupType).label);
                    }
                    if (values.masterDetailGroupType) {
                        const masterGroupLabel = masterGroupTypeOptions.find((item) => item.value === values.masterDetailGroupType).label
                        setFieldValue('masterGroupLabel', masterGroupLabel)
                    }
                } : () => { }}>{translate.byKey(TranslationKeys.next)}</button>
        </div>
    </div >;
}

export default MasterDetailGroupType;
